export default {
  computed: {
    userHasAccessToApproveOrders () {
      return this.$store.getters['header/userCanApproveOrders'] ?? false
    }
  }
}
